import { dataArraySieve } from "@smp/utils";

const AVAILABLE_TAGS = ["category", "type", "color", "theme"];
const AVAILABLE_SORT = ["-popularity", "created_at"];

export const queryParams = {
  deserialize: (string?: string) => {
    string =
      string || typeof window !== "undefined" ? window.location.search : "";

    const params = string
      ? Object.fromEntries(new URLSearchParams(string))
      : {};

    return {
      search: params.search,
      tags: dataArraySieve(
        AVAILABLE_TAGS.map((tag) =>
          params[tag] ? `${tag}_${params[tag]}` : undefined,
        ),
      ),
      sort: AVAILABLE_SORT.includes(params.sort) ? params.sort : undefined,
    };
  },

  deserializeUnsplashData: (str: string) => {
    try {
      const json = decodeURIComponent(
        window.atob(
          str.replace(/\./g, "+").replace(/_/g, "/").replace(/-/g, "="),
        ),
      );

      return JSON.parse(json) as {
        url: string;
        user_name?: string;
        user_link?: string;
        query?: string;
      };
    } catch (e) {
      return undefined;
    }
  },

  serialize: (search: string, tags: string[], sort?: string) => {
    const queryParams = tags.reduce<Record<string, string>>((acc, tag) => {
      const [key, value] = tag.split(/_(.*)/s);

      if (key && value && AVAILABLE_TAGS.includes(key)) {
        acc[key] = value;
      }

      return acc;
    }, {});

    if (search) {
      queryParams.search = search;
    }

    if (sort && AVAILABLE_SORT.includes(sort)) {
      queryParams.sort = sort;
    }

    const query = new URLSearchParams(queryParams).toString();

    return query ? `?${query}` : "";
  },

  serializeUnsplashData: (data: {
    url: string;
    user_name?: string;
    user_link?: string;
    query?: string;
  }) => {
    const string = encodeURIComponent(JSON.stringify(data));
    const base64 = window.btoa(string);

    return base64.replace(/\+/g, ".").replace(/\//g, "_").replace(/=/g, "-");
  },
};
